<template>
  <!-- Version: 1.2 -->
  <h2>1. Opis igre</h2>
  <p>
    Utakmica Svjetskog prvenstva IIHF Highlight Games jedinstvena je softverska simulacija nasumično odabranih najboljih
    trenutaka hokeja na ledu s utakmica kako bi se stvorile prilike za igranje.
  </p>
  <h2>2. Opis i trajanje igre</h2>
  <p>
    Jedan krug elektroničke igre na sreću traje u prosjeku 5 minuta i sastoji se od najave utakmica, prikaz i rezultati.
    Izbor najvažnijih hokejaških događaja je statistički neovisan, slučajan i nepredvidljiv, a generiran generatorom
    slučajnih brojeva
  </p>
  <h2>3. Tržišta klađenja</h2>
  <h3>3.1 Točan broj golova (uključujući produžetke)</h3>
  <p>
    Značenje klađenja na točan broj golova je da mora biti postignut točan broj golova postignut u jednoj utakmici.
    Dakle, ova varijacija klađenja znači da morate predvidjeti precizan broj golova unatoč konačnom ishodu cijele
    utakmice.
  </p>
  <h3>3.2 Točan broj golova domaće momčadi (uključujući produžetke)</h3>
  <p>Oklada na točan broj golova koje će domaća momčad postići u utakmici.</p>
  <h3>3.3 Točan broj golova gostujuće momčadi (uključujući produžetke)</h3>
  <p>Oklada na točan broj golova koje će gostujuća momčad postići u utakmici.</p>
  <h3>3.4 Oba tima daju gol (regularno vrijeme)</h3>
  <p>
    Za dobitak BTTS oklade, oba tima moraju postići barem jedan gol, što znači da je rezultat 1-1. i više, dobitna
    oklada. iskoristite takve događaje kako biste ostvarili profitabilne kvote kada je samo jedan od ta dva timovi su
    uspjeli postići gol.
  </p>
  <h3>3.5 Točan rezultat (uključujući produžetke)</h3>
  <p>
    Klađenje na točan rezultat je klađenje na ono što mislite da će biti konačni ishod hokejaške utakmice Utakmica će se
    igrati s maksimalno 5 golova, a u njoj postoji 18 mogućih ishoda.
  </p>
  <h3>3.6 Rezultat utakmice (1X2) (regularno vrijeme)</h3>
  <p>Oklada na pobjedu domaće momčadi (1), pobjedu gostujuće momčadi (2) ili neriješen rezultat utakmice (X).</p>
  <h3>3.7 Rezultat utakmice (1,2) (uključujući produžetke)</h3>
  <p>Oklada na pobjedu domaće momčadi (1), pobjedu gostujuće momčadi (2).</p>
  <h3>3.8 Rezultat utakmice i Iznad/Ispod 3.5 golova (Regularno vrijeme)</h3>
  <p>Oklada na rezultat utakmice i ukupan broj golova koji će biti ispod ili iznad 3,5 gola.</p>
  <h3>3.9 Rezultat utakmice i Iznad/Ispod 3.5 golova (Uključujući produžetke)</h3>
  <p>Oklada na rezultat utakmice i ukupan broj golova koji će biti ispod ili iznad 3,5 gola.</p>
  <h3>3.10 Iznad/Ispod 2.5 Golova domaće ili gostujuće momčadi (Uključujući produžetke)</h3>
  <p>Oklada da će Domaćin ili Gostujući Tim postići više ili manje od 2,5 gola.</p>
  <h3>3.11 Više od 2.5, 3.5, 4.5 Ukupno golova (uključujući Produžeci)</h3>
  <p>Oklada na ukupan broj postignutih golova obje momčadi, a to je više od 2,5, 3,5 ili 4,5 u utakmica.</p>
  <h3>3.12 Kladionice s kvotama za favorita ili autsajdera u utakmici.</h3>
  <p>Hendikep stvara liniju hendikepa od &#39;pola gola&#39; između dva tima, gdje postoje 2 moguća ishodi.</p>
  <h3>3.13 Klađenje na utakmice s 3 kvote (regularno vrijeme)</h3>
  <p>
    Klađenje s kvotama postavljenim za određivanje favorita ili autsajdera u utakmici. Hendikep stvara liniju hendikepa
    &#39;cijeli gol&#39; između dva tima, gdje postoje 3 mogući ishodi (tj. uključujući neriješeno).
  </p>
  <h3>3.14 Oklade na period s najviše postignutih golova (regularno vrijeme)</h3>
  <p>Oklada na period s najviše postignutih golova. To može biti period 1, period 2, Treća trećina ili neriješeno.</p>
  <h3>3.15 Tim koji će osvojiti najviše trećina (regularno vrijeme)</h3>
  <p>Oklada na to koji će tim osvojiti najviše trećina. To može biti Domaćin, Gostujući tim ili Kravata.</p>
  <h3>3.16 Koji će tim prvi postići gol? (Uključujući Produžeci)</h3>
  <p>Oklada na to koja će momčad prva postići gol u utakmici?</p>
</template>
